module.exports = __webpack_public_path__ + "img/xinjian3.69cfb7f2.svg";